import { cva } from 'class-variance-authority';

/**
 * Barre haute des formats étroits, relevée sur `.ptop` des maquettes
 * `meeply-home-formats` (variante bonjour) et `meeply-library-formats`
 * (variante titre).
 */
export const appTopBarStyles = {
  root: cva([
    'flex items-center gap-3 px-4 pb-3',
    // Réserve de l'encoche : la barre est le premier élément de l'écran.
    'pt-[calc(0.5rem+env(safe-area-inset-top))]',
    // Collée en haut : la cloche, les messages et l'avatar restent atteignables
    // sans remonter toute la page.
    //
    // ⚠️ `bg-app-top` et non `bg-app` — la tranche du dégradé ancrée en haut de
    // la fenêtre. Le décor est figé derrière ; la barre repeint donc exactement
    // les pixels qu'il aurait montrés là, à n'importe quelle hauteur de
    // défilement. `bg-app` étirerait le dégradé sur la seule hauteur de la
    // barre et poserait un bandeau bleu vif sur un fond devenu sombre.
    //
    // ⚠️ z-30 : au-dessus du contenu et des barres d'action collantes (z-10,
    // z-20), sous le tiroir et les surcouches (z-50).
    'sticky top-0 z-30 bg-app-top',
  ]),

  /** Déclencheur du tiroir. 44 px de cible, pour un avatar de 40. */
  avatarButton: cva([
    'grid size-11 shrink-0 place-items-center rounded-full p-0.5',
    'transition-colors outline-none',
    'hover:bg-surface-hover focus-visible:ring-2 focus-visible:ring-accent/60',
  ]),

  /** Bouton d'action à droite (notifications, messages). */
  iconButton: cva([
    'relative grid size-10 shrink-0 place-items-center rounded-panel',
    'border border-border bg-surface text-fg-muted',
    'transition-colors outline-none',
    'hover:bg-surface-hover hover:text-fg',
    'focus-visible:ring-2 focus-visible:ring-accent/60',
  ]),

  /**
   * Pastille de notification : un simple point, sans nombre — c'est ce que
   * montre la maquette, là où les messages portent un compteur.
   */
  dot: cva([
    'absolute -top-0.5 -right-0.5 size-2.5 rounded-full',
    'border-2 border-canvas-bottom bg-danger',
  ]),

  badge: cva([
    'absolute -top-1.5 -right-1.5 grid h-4 min-w-4 place-items-center rounded-full px-1',
    'border-2 border-canvas-bottom bg-accent',
    'text-4xs font-bold text-white tabular-nums',
  ]),
};
